window.TableFrame = (function ($) {
    window.dataLayer = window.dataLayer || [];
    /**
     * @type {{}||Object<string, VitalityTable>}
     */
    window.VitalityTables = window.VitalityTables || {};
    const self = {
        selectors: {
            sortOptions: '.sort-option',
            filterOptions: '.filter-option',
            selectedSortOption: '.sort-option:checked',
            checkedFilterOptions: '.filter-option:checked',
            normalModeTableFrames: '.table-frame[data-frame-mode="normal"]'
        },
        attr: {
            dataColumnNumber: 'data-column-number',
            dataSortDirection: 'data-sort-direction',
            dataFilterValue: 'data-filter-value'
        },
        state: {
            channel: new BroadcastChannel('table-frame-update')
        },
        func: {
            init: function () {
                // Only happens in normal mode (Not XP editor)
                $(self.selectors.normalModeTableFrames).each((_index, element) => {
                    let table = $(element);
                    table.find(self.selectors.sortOptions).first().prop('checked', true);
                    table.find(self.selectors.filterOptions).prop('checked', true);
                    self.func.bind(table);
                    self.func.handleUpdate(table);
                });
            },
            bind: function (table) {
                let handleUpdateForTable = () => {
                    self.func.handleUpdate(table);
                };
                $(self.selectors.sortOptions).on('change', handleUpdateForTable);
                $(self.selectors.filterOptions).on('change', handleUpdateForTable);
            },
            handleUpdate: function (table) {
                let tableId =  table.attr('id');

                window.VitalityTables[tableId] = window.VitalityTables[tableId] || {
                    tableFrame: {},
                    tableData: {}
                };

                window.VitalityTables[tableId].tableFrame = {
                    isPopulated: true,
                    sort: self.func.getSortData(table),
                    filters: self.func.getFilterData(table)
                };

                // Tables should subscribe to this channel so they know when search/filter/sort values change
                // The tableId sent in the message identifies which table frame has changed
                // The corresponding data lives in window.VitalityTables[tableId]
                self.state.channel.postMessage(tableId);
            },
            getSortData: function (table) {
                let selectedInput = table.find(self.selectors.selectedSortOption).first();
                return {
                    columnNumber: selectedInput.attr(self.attr.dataColumnNumber),
                    sortDirection: selectedInput.attr(self.attr.dataSortDirection)
                };
            },
            getFilterData: function (table) {
                let checkedFilters = table.find(self.selectors.checkedFilterOptions);
                let filterList = [];
                checkedFilters.each((_index, element) => {
                    let checkbox = $(element);
                    let obj = {
                        columnNumber: checkbox.attr(self.attr.dataColumnNumber),
                        filterValue: checkbox.attr(self.attr.dataFilterValue)
                    };
                    filterList.push(obj);
                });
                return filterList;
            }
        }
    };

    return {
        init: self.func.init,
        experienceEditorInit: self.func.experienceEditorInit
    };
})(window.jQuery);

$('document').ready(function () {
    window.TableFrame.init();
});
